const regexPatterns = {
  'string': /^[\s\S]*$/,// Not checked
  'number': /^-?\d+$/,
  longNumber: /^\d{10,}$/,// Not checked
  'longNumber+2float': /.*/, // everyThing,,// Not checked
  smallNumber: /^\d{1,9}$/,// Not checked
  smallFloat: /.*/, // everyThing,,// Not checked
  longFloat: /.*/, // everyThing,,// Not checked
  'date': /^(?!0000\/00\/00)\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2]\d|3[0-1])$/, // Not checked
  time: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // checked
  mobile: /^09\d{9}$/, // checked
  telephone: /.*/, // everyThing
  email: /^[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/,  // checked
  price: /.*/, // everyThing, but i will check on Change
  color: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
  year: /.*/, // everyThing,
  month: /.*/, // everyThing,
  day: /.*/, // everyThing,
  selectBox: /.*/,
  cashBox: /.*/,
  rlookup: /.*/,
  file: /.*/,
  textarea: /.*/,
  editor: /.*/,
};

// Example usage:
// const inputValue = 'your_input_value';
// const inputType = 'number'; // Replace with the desired type
//
// if (regexPatterns[inputType].test(inputValue)) {
// } else {
// }


export const validatePlease = ({title, inputType, inputValue, required}) => {
  if (required && !inputValue) {
    return title + ' اجباری است.'
  }



  if (!(regexPatterns[inputType]?.test(inputValue))) {
    return `فرمت ${title} صحیح نیست`;
  }

  return ''

}
export const validateFormObject = (formConfig) => {
  const temp = {
    status: true, formConfig: [...formConfig]
  }


  temp?.formConfig?.forEach(row => {


    const inputValue = row.value;
    const inputType = row.type
    const required = row.required
    const title = row.title

    // خیلی مرتب پیش میریم  اول نگاه میکنیم که باید  اینپوتی که ولیدیت میکنیم
    // باید مقدار ویزیبیلتی ترو باشه و دیده بشه
    if (row.visible) {
      // حالا میایم بررسی میکنیم.  اگه خالی نبود باید ولیدیت کنم
      // همچنین باید  اجباری بودنش رو چک کنم.
      // اگه اینپوتی بود که اجباری بود و خالی بود باید حتما ولیدیت بشه
      if (inputValue || required) {
        row.errorMessage = validatePlease({title, inputType, inputValue, required})
        if (row.errorMessage) {
          temp.status = false
        }
      }
    }
  })


  return temp
}

